export default __webpack_public_path__ + "static/media/location.e288da27.svg";